export default __webpack_public_path__ + "media/images/delete-6e5f1cb4ee088d6dfb3c513f0989b678.png";